export default __webpack_public_path__ + "static/media/landingpage-logo.0c4928f1.png";